import * as React from "react";

export default function({style = {}, ...props}) {
    return <small
        className={'border d-inline-block rounded-3 border-info ms-1'}
        style={{
            lineHeight: '13px',
            width: '14px',
            textAlign: 'center',
            color: 'grey',
            ...style
        }}
    >
        ?
    </small>
}